module.exports = __webpack_public_path__ + "img/banner-4.d605839f.jpg";